'use client';

import React from 'react';
import { DefaultDropdown } from '@/components/ui/DefaultDropdown';
import { RegFormField } from '@/features/b2b/register/components/RegFormField';
import { NETWORK_OPTIONS } from '@/features/b2b/register/services/registrationService';

export const NetworkSelectionForm = ({ formData, handleSelectChange, errors }) => {
  return (
    <>
      <p className="text-[#373945] text-base font-medium mb-2">
        Member of network?
      </p>

      <div className={`mb-${formData.mon === 'Other' ? '6' : '12'} focus:outline-none focus:border-[#006EB7]`}>
        <DefaultDropdown
          items={NETWORK_OPTIONS}
          onItemSelect={(selectedValue) => {
            handleSelectChange('mon')(selectedValue);
            if (selectedValue !== 'Other' && formData.monOther !== '') {
              handleSelectChange('monOther')('');
            }
          }}
          title={formData.mon || 'Select network'}
          maxHeight="max-h-96"
          errorClass={errors.mon ? 'border-2 border-[#D32F2F]' : ''}
        />
      </div>

      {formData.mon === 'Other' && (
        <RegFormField
          label='If "Other" Enter Here'
          name="monOther"
          value={formData.monOther}
          onChange={(e) => handleSelectChange('monOther')(e.target.value)}
          placeholder="Example LTD"
          required={formData.mon === 'Other'}
          error={errors.monOther}
          className="mb-12"
        />
      )}
    </>
  );
};
